<cfp-self-onboarding-layout>
  @if (isRegistrationClosed) {
    <cfp-self-onboarding-registration-closed />
  } @else {
    <cfp-self-onboarding-create-account
      [showCountryOfIncorporation]="showCountryOfIncorporation"
      [showSector]="showSector"
      [showRelationManagerName]="true"
      [loading]="isLoading()"
      (previous)="previous()"
      (next)="next($event)"
    />
  }
</cfp-self-onboarding-layout>
